import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const TextFieldStyled = styled.div`
  position: relative;
  margin-bottom: 5px;
  margin-top: 28px;
  padding: 0;
  
  input {
    width: 100%;
    background: transparent;
    border: none;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    border-bottom-color: ${props => props.error ? '#CD2028' : '#bcaaa3'};
    border-radius: 0;
    box-shadow: none;
    padding: 10px 13px 3px 13px;
    font-family: IntroBold;
    font-size: 17.5px;
    color: #3e2723;
  }
  
  .show, input:focus + label {
    top: -12px;
    font-size: 10.5px;
  }
  
  input:focus + label {
    color: ${props => props.error ? '#CD2028' : '#04A2DC'};
  }
  
  .show {
    color: ${props => props.error ? '#CD2028' : '#BCAAA3'};
  }
  
  input:focus {
    border-bottom-color: ${props => props.error ? '#CD2028' : '#04A2DC'};
  }
  
  .label-error-span {
      color: #CD2028;
      font-weight: 400;
      text-transform: none;
    }
`;

const LabelStyled = styled.label`
    position: absolute;
    left: 13px;
    top: 13px;
    font-size: 14px;
    color: #bcaaa3;
    transition: all 0.2s cubic-bezier(0.65, 0.05, 0.36, 1);
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 1px;
`;

const ErrorSpanStyled = styled.span`
    display: ${props => props.show ? 'inline' : 'none'};
    text-transform: capitalize;
    color: #CD2028;
    font-weight: 400;
`;

class TextField extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            value: this.props.value,
            error: this.props.error,
            isPopulated: !!(this.props.value)
        };
    }

    componentWillReceiveProps(nextProps) {
        const newState = {};
        if (nextProps.value !== this.state.value) {
            newState.value = nextProps.value;
        }
        if (nextProps.error !== this.state.error) {
            newState.error = nextProps.error;
        }
        this.setState(newState);
    }

    onChange(e) {
        const value = e.target.value;

        this.setState(
            { value, isPopulated: !this.state.isPopulated ? true : this.state.isPopulated },
            this.props.onChangeHandler(value)
        );
    }

    formatId() {
        return this.props.label.toLowerCase().replace(' ', '_');
    }

    render() {
        const show = (this.state.isPopulated || !!this.state.value || !!this.state.error) ? 'show' : '';
        const errorState = !!this.state.error;

        return (
            <TextFieldStyled className='custom-input-field' error={errorState}>
                <input readOnly={this.props.readOnly}
                       id={`${this.formatId()}_input`}
                       required={this.props.required}
                       onChange={this.onChange.bind(this)}
                       onBlur={this.props.validate}
                       type={this.props.type}
                       value={this.state.value}/>
                <LabelStyled className={show}
                             htmlFor={`${this.formatId()}_input`} >
                    {`${this.props.label} `}
                    <ErrorSpanStyled show={errorState}>
                        {this.state.error}
                    </ErrorSpanStyled>
                </LabelStyled>

            </TextFieldStyled>
        );
    }


}

TextField.propTypes = {
    onChangeHandler: PropTypes.func,
    validate: PropTypes.func,
    readOnly: PropTypes.bool,
    required: PropTypes.bool,
    label: PropTypes.string,
    value: PropTypes.string,
    type: PropTypes.string,
    error: PropTypes.string
};

TextField.defaultProps = {
    onChangeHandler: () => {},
    validate: () => {},
    readOnly: false,
    required: false,
    label: '',
    value: '',
    type: 'text',
    error: ''
};

export default TextField;



// WEBPACK FOOTER //
// ./src/components/TextField/index.js